import {
  combineReducers
} from 'redux';

import modalReducer from './modalReducer';
import secondModalReducer from './secondModalReducer';
import snackBarReducer from './snackBarReducer';
import loginReducer from './loginReducer';
import OffLineSupporteReducer from "../OffLineSupport-Panel/reducers/OffLineSupportReducer";



// import notificationReducer from './notificationReducer';


const rootReducer = combineReducers({
  modalReducer,
  secondModalReducer,
  snackBarReducer,
  loginReducer,
  OffLineSupporteReducer,
});

export default rootReducer;